export const PICKER_MODE = {
  DATE: "date",
  TIME: "time",
} as const;

export type PickerMode = typeof PICKER_MODE[keyof typeof PICKER_MODE];
